import React from "react";
import { motion } from "framer-motion";

import { Wrapper, Content, CenterMassiveText, TextContainer } from "./NotFound.styles";
import {contentVariants, useIsFirstLoad} from '../variants';

const NotFound = () => {
	const isFirstLoad = useIsFirstLoad();
	return (
		<Wrapper>
			<motion.div variants={contentVariants} initial={isFirstLoad ? false : "hidden"} animate="visible" exit="exit">
				<Content>
					<TextContainer>
						<CenterMassiveText>
							<div class="glitch" data-glitch="Page Not Found">
								Page Not Found
							</div>
						</CenterMassiveText>
					</TextContainer>
				</Content>
			</motion.div>
		</Wrapper>
	);
};

export default NotFound;
